import { render } from "./TrafficInfo.vue?vue&type=template&id=5e7076c7&ts=true"
import script from "./TrafficInfo.vue?vue&type=script&lang=ts"
export * from "./TrafficInfo.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__